export const NAME = 'ACCESS_PERIOD';

export const RECEIVE_SUBSCRIPTION_DETAILS = `${NAME}/RECEIVE_SUBSCRIPTION_DETAILS`;

export const ACTIVE_TO_UPDATED = `${NAME}/ACTIVE_TO_UPDATED`;
export const ACTIVE_FROM_UPDATED = `${NAME}/ACTIVE_FROM_UPDATED`;

export const RESET_STATE = `${NAME}/RESET_STATE`;
